import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Menu from "@/pages/Menu";

// Paginile juridice nu sunt necesare la primul paint → lazy (scoase din bundle-ul inițial).
const PrivacyPolicy = lazy(() => import("@/pages/PrivacyPolicy"));
const CookiePolicy = lazy(() => import("@/pages/CookiePolicy"));
const Terms = lazy(() => import("@/pages/Terms"));

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Suspense fallback={<div className="min-h-screen bg-roty-cream" />}>
          <Routes>
            <Route path="/" element={<Menu />} />
            <Route path="/politica-confidentialitate" element={<PrivacyPolicy />} />
            <Route path="/politica-cookies" element={<CookiePolicy />} />
            <Route path="/termeni-si-conditii" element={<Terms />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  );
}

export default App;
